import { Row, Col, Card, CardBody, Input, Label, Button, Form, Alert, Modal } from "reactstrap";
import { Trans } from 'react-i18next';
import React, { useCallback, useRef, useState, useEffect } from 'react';
import { GoogleMap, useJsApiLoader, Polygon, Marker, Autocomplete, StandaloneSearchBox  } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '600px'
};
const libs = ['maps', 'places'];
const MapComponent = ({marker, setMarker}) => {

    const [searchBox, setSearchBox] = useState(null);
    const [zoom, setZoom] = useState(10);
    const [center, setCenter] = useState({
      lat: 24.712186535213522,
      lng: 55.11976906855254
    });
    const inputStyle = {
      boxSizing: `border-box`,
      border: `1px solid transparent`,
      width: `240px`,
      height: `32px`,
      padding: `0 12px`,
      borderRadius: `3px`,
      boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
      fontSize: `14px`,
      outline: `none`,
      textOverflow: `ellipses`,
      position: 'absolute',
      top: '10px',
      right: '10px',
     
    }

    useEffect(()=>{ 
    setTimeout(()=>{
      require('../../common/map-contains.js');
    },500)
  },[]);

    useEffect(()=>{
      setCenter(marker); 
  },[marker]);

  const  isLoaded  = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyB_0WjJZTplrgiW8rTo3TWx97u-C1WutB0',
    libraries: libs
  });

  const handleOnClick = (e) => {
    const latLng = e.latLng;

    if (latLng) {
      const lat = latLng.lat();
      const lng = latLng.lng();
      setMarker({
        lat: lat,
        lng: lng,
      });
    }
  };
  const handleLoad = aref => {
    setSearchBox(aref);
  }

  const hanldePlacesChanged = ref => {
      setMarker({
        lat: searchBox.getPlaces()[0].geometry.location.lat(),
        lng: searchBox.getPlaces()[0].geometry.location.lng(),
      });
      setCenter({
        lat: searchBox.getPlaces()[0].geometry.location.lat(),
        lng: searchBox.getPlaces()[0].geometry.location.lng(),
      });
      setZoom(13);
  }

  return isLoaded.isLoaded ? (
    <Row >
      <div style={{position:'relative', zIndex:0}}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={zoom}
          onClick={handleOnClick}
          libraries={libs}
        >
          <StandaloneSearchBox onPlacesChanged={hanldePlacesChanged} onLoad={handleLoad} >
            <input
              type='text'
              placeholder='Search location'
              style={inputStyle}
            />
          </StandaloneSearchBox>
          {marker && (
          <Marker
            position={{
              lat: marker.lat,
              lng: marker.lng,
            }}
          />
        )}
        </GoogleMap>

      </div>
    </Row>
  ) : <></>;
};
export default MapComponent;